import classNames from "classnames";
import { TEntityInfo } from "../../../types/utility";
import { TSidebarActions } from "../../types";
import { AskGPTButton } from "../SidebarButtons/AskGPTButton";
import { SoundToTextButton } from "../SidebarButtons/SoundToTextButton";
import styles from "./styles.module.css";

interface Props {
  isSidebarOpen: boolean;
  handleActions: (type: TSidebarActions, info: TEntityInfo | null) => void;
}

export const SidebarFooter = ({ isSidebarOpen, handleActions }: Props) => {
  const cls = classNames(
    styles["sidebar-footer"],
    !isSidebarOpen && styles["sidebar-footer-close"],
  );
  return (
    <div className={cls}>
      <AskGPTButton
        btnType={isSidebarOpen ? "text_btn" : "icon_btn"}
        onClick={() => handleActions("ask_gpt", null)}
      />
      <SoundToTextButton
        btnType={isSidebarOpen ? "text_btn" : "icon_btn"}
        onClick={() => handleActions("sound_to_text", null)}
      />
    </div>
  );
};
